module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAACpSURBVEhL7Y4xCsJAEEW39BaS1ht4FguxyDFsxCrnkFTxKmlynMjqH3gQZI0OsuU8WAL//zckBUGw8KwMZxfIq8HZd3LOo5X67oncmIM7EpWoHBgdiNyYgzsQlajsGJ2J3JiD2xGVqGwZ3YncmIPbEpWobPRmvYfeUfsN1Sq20faEY+6W6jMaXO1P/kHuhTPf0bDHcSPnhv4bjSekHdEqtmE7EQVBVVJ6ASkPpbB/kn2IAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/img/services/img/i8-bath/light/24.png
// module id = 1874
// module chunks = 2